import { useCallback, useEffect, useState } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;
const KEY = 'gp-theme';

/* Per-user Game Plan theme ('dark' | 'light'): instant from localStorage, synced to the user's profile. */
export default function useGpTheme(token) {
  const [theme, setThemeState] = useState(() => (typeof window !== 'undefined' && window.localStorage.getItem(KEY)) || 'dark');
  const [switching, setSwitching] = useState(false);

  useEffect(() => {
    if (!token) return;
    fetch(`${API}/api/home/gameplan-theme`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (d?.theme === 'light' || d?.theme === 'dark') { setThemeState(d.theme); window.localStorage.setItem(KEY, d.theme); } })
      .catch(() => {});
  }, [token]);

  const toggle = useCallback(() => {
    const next = theme === 'light' ? 'dark' : 'light';
    setSwitching(true);
    setThemeState(next);
    window.localStorage.setItem(KEY, next);
    setTimeout(() => setSwitching(false), 600);
    if (token) {
      fetch(`${API}/api/home/gameplan-theme`, { method: 'PUT', headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }, body: JSON.stringify({ theme: next }) }).catch(() => {});
    }
  }, [theme, token]);

  return { theme, toggle, switching };
}
